import { IsIn, IsNotEmpty, IsOptional, IsArray, IsBoolean } from "class-validator";
import { Constants } from "@eagerdog/constants";

import { IShedDogScore } from "./shed-dog-score.interface";

// -------------------
export class ShedDogScoreDto implements IShedDogScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsOptional()
  result_reason?: string;

  @IsOptional()
  @IsArray()
  finds?: boolean[];

  @IsOptional()
  search_time?: number; //mm:ss:tt. Only if passed == true

  @IsOptional()
  @IsBoolean()
  excluded_from_placement?: boolean;
}
